import { useState, Fragment,createContext, useContext  } from 'react';

const PredContext = createContext();

const PredProvider = ({ children }) => {

const [teamData, setTeamData] = useState([]);
const [id, setId] = useState();
  const [lines, setLines] = useState({});

const clearLines = () => {
  setLines({}); // Resets the lines state object
};
  return (
    <PredContext.Provider value={{clearLines,lines, setLines,teamData, setTeamData, id, setId}}>
      {children}
    </PredContext.Provider>
  );
  }
  export {PredContext,PredProvider}